import { Checkbox } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

interface Props {
  onFilter: (value: boolean) => void
  value?: boolean
}

const ClaimedToggle: React.FC<Props> = ({ onFilter, value }) => {
  const { tRoute } = useTranslation({ scope: 'invoice.index' })

  function onChecked(event: CheckboxChangeEvent) {
    onFilter(event.target.checked)
  }

  return (
    <Checkbox onChange={onChecked} checked={value}>
      {tRoute({ id: 'show_claimed_invoices' })}
    </Checkbox>
  )
}

export default ClaimedToggle
